var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _rect2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawSurvey05S5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_survey_05s5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 443.396,
    height: 317.697,
    viewBox: "0 0 443.396 317.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_286",
    "data-name": "Trazado 286",
    d: "M844.037,708.724H659.785a.612.612,0,0,1,0-1.224H844.037a.612.612,0,0,1,0,1.224Z",
    transform: "translate(-401.254 -391.028)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_287",
    "data-name": "Trazado 287",
    d: "M528.4,489.207h-7.5l-3.57-28.947H528.4Z",
    transform: "translate(-200.654 -178.52)",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_288",
    "data-name": "Trazado 288",
    d: "M508.627,504.045H523.1v9.113H499.515A9.113,9.113,0,0,1,508.627,504.045Z",
    transform: "translate(-193.746 -195.503)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_289",
    "data-name": "Trazado 289",
    d: "M610.37,476.978l-6.827,3.118-15.275-24.846,10.074-4.6Z",
    transform: "translate(-228.171 -174.792)",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_290",
    "data-name": "Trazado 290",
    d: "M9.113,0H23.586V9.113H0A9.113,9.113,0,0,1,9.113,0Z",
    transform: "translate(361.315 309.368) rotate(-24.548)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_291",
    "data-name": "Trazado 291",
    d: "M820.2,519.949a6.155,6.155,0,0,0,.49-9.426l8.822-20.017-11.207,1.9-6.659,18.717a6.189,6.189,0,0,0,8.554,8.826Z",
    transform: "translate(-459.854 -306.863)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_292",
    "data-name": "Trazado 292",
    d: "M761.371,615.934H754.2a2.765,2.765,0,0,1-2.747-2.555l-7.583-104.4a2.754,2.754,0,0,1,3.015-2.941l45.135,4.4a2.755,2.755,0,0,1,2.487,2.689l.869,46.054a2.138,2.138,0,0,0,.143.73l17.008,44.106a2.754,2.754,0,0,1-1.618,3.575l-7.265,2.677a2.755,2.755,0,0,1-3.4-1.325l-20.894-40.627a2.733,2.733,0,0,1-.248-.7l-3.569-17.2a2.142,2.142,0,0,0-4.226.191l-7.2,62.88a2.754,2.754,0,0,1-2.737,2.441Z",
    transform: "translate(-434.103 -312.88)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_203",
    "data-name": "Elipse 203",
    cx: 15.035,
    cy: 15.035,
    r: 15.035,
    transform: "translate(315.804 84.391)",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_293",
    "data-name": "Trazado 293",
    d: "M748.551,462.87c1.924,1.328,23.608,15.617,48.323,4.251-.32-2.76-3.4-30.472-.711-50.9a25.836,25.836,0,0,0-10.589-24.636,30.443,30.443,0,0,0-30.619-3.306h0q-.609.273-1.226.567Z",
    transform: "translate(-435.92 -266.173)",
    fill: "#58b957"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_294",
    "data-name": "Trazado 294",
    d: "M821.319,477.88a2.746,2.746,0,0,1-2.027-.894L816,473.4a2.769,2.769,0,0,1-.611-2.642l7.532-25.494L811.464,421.2a5.086,5.086,0,0,1,9.07-4.6l15.493,25.139a7.009,7.009,0,0,1,.422,6.568l-12.616,27.953a2.748,2.748,0,0,1-2.075,1.587A2.793,2.793,0,0,1,821.319,477.88Z",
    transform: "translate(-460.131 -277.159)",
    fill: "#58b957"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_295",
    "data-name": "Trazado 295",
    d: "M762.921,481.816h-6.007l10.485-49.34.6.079L765.672,479.2A2.752,2.752,0,0,1,762.921,481.816Z",
    transform: "translate(-439.164 -284.355)",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_296",
    "data-name": "Trazado 296",
    d: "M750.752,513.645a6.155,6.155,0,0,0-1.477-9.322l4.474-21.412L743.18,487.1l-2.628,19.692a6.189,6.189,0,0,0,10.2,6.858Z",
    transform: "translate(-432.553 -303.917)",
    fill: "#ffb8b8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_297",
    "data-name": "Trazado 297",
    d: "M750.85,465.239a2.871,2.871,0,0,1-.311-.017l-6.406-.712a2.764,2.764,0,0,1-2.448-2.851l2.651-64.141A8.281,8.281,0,0,1,760.7,396.1l1.707,7.854-.008.056-8.832,58.883A2.745,2.745,0,0,1,750.85,465.239Z",
    transform: "translate(-433.257 -267.716)",
    fill: "#58b957"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_298",
    "data-name": "Trazado 298",
    d: "M778.341,352.848c-1.559.267-2.842-1.9-3.036-3.429s.362-2.988.423-4.5-.654-3.359-2.229-3.809c-1.651-.471-3.182.853-4.872.694-2.355-.222-3.538-2.979-3.823-5.208s-.51-4.871-2.549-6.142-4.549-.345-6.886-.306a9.4,9.4,0,0,1-8.892-6.661,2.24,2.24,0,0,0,2.555-1.023,2.267,2.267,0,0,0-.682-2.68l4.477,2.192a2.4,2.4,0,0,1,1.584-3.135,8.457,8.457,0,0,1,4.155-.042c7.009,1.089,15.128.552,19.777,5.9,3.22,3.7,5.871,10.746,5.509,15.3S778.341,352.848,778.341,352.848Z",
    transform: "translate(-435.115 -240.167)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_299",
    "data-name": "Trazado 299",
    d: "M410.448,472.693H249.457a4.29,4.29,0,0,1-4.285-4.285L237.827,194.8a4.293,4.293,0,0,1,4.285-4.3H403.1a4.29,4.29,0,0,1,4.285,4.285l1.331,49.566-1.224.033L406.163,194.8a3.068,3.068,0,0,0-3.061-3.077H242.112a3.064,3.064,0,0,0-3.061,3.061L246.4,468.392a3.068,3.068,0,0,0,3.061,3.077H410.448a3.064,3.064,0,0,0,3.061-3.061l-1.429-53.239,1.224-.033,1.43,53.255a4.293,4.293,0,0,1-4.285,4.3Z",
    transform: "translate(-237.827 -190.5)",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_704",
    "data-name": "Rect\\xE1ngulo 704",
    width: 1.224,
    height: 23.506,
    transform: "matrix(1, -0.027, 0.027, 1, 171.64, 127.339)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_300",
    "data-name": "Trazado 300",
    d: "M405.555,463.859H272.2a3.659,3.659,0,0,1-3.655-3.655l-6.085-226.643a3.662,3.662,0,0,1,3.654-3.671H399.47a3.659,3.659,0,0,1,3.655,3.655l1.1,26.075-1.223.051-1.1-26.1a2.44,2.44,0,0,0-2.431-2.456H266.111a2.433,2.433,0,0,0-2.43,2.43l6.085,226.643a2.437,2.437,0,0,0,2.431,2.447H405.555a2.433,2.433,0,0,0,2.43-2.43l-.788-29.758,1.224-.032.788,29.774a3.662,3.662,0,0,1-3.654,3.671Z",
    transform: "translate(-247.38 -205.778)",
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_705",
    "data-name": "Rect\\xE1ngulo 705",
    width: 1.224,
    height: 23.269,
    transform: "translate(157.256 127.952) rotate(-1.516)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_301",
    "data-name": "Trazado 301",
    d: "M451.024,352.18H294.93a4.29,4.29,0,0,1-4.285-4.25L288.2,281.785a4.29,4.29,0,0,1,4.285-4.285H448.575a4.29,4.29,0,0,1,4.285,4.25l2.449,66.146a4.29,4.29,0,0,1-4.285,4.285Zm-161.6-70.427,2.448,66.143a3.064,3.064,0,0,0,3.061,3.061H451.024a3.064,3.064,0,0,0,3.061-3.028l-2.448-66.143a3.064,3.064,0,0,0-3.061-3.061H292.482A3.064,3.064,0,0,0,289.421,281.753Z",
    transform: "translate(-257.364 -224.244)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_302",
    "data-name": "Trazado 302",
    d: "M499.024,511.18H342.93a4.29,4.29,0,0,1-4.285-4.25L336.2,440.785a4.29,4.29,0,0,1,4.285-4.285H496.575a4.29,4.29,0,0,1,4.285,4.25l2.449,66.146a4.29,4.29,0,0,1-4.285,4.285Zm-161.6-70.427,2.448,66.143a3.064,3.064,0,0,0,3.061,3.061H499.024a3.064,3.064,0,0,0,3.061-3.028l-2.448-66.143a3.064,3.064,0,0,0-3.061-3.061H340.482a3.064,3.064,0,0,0-3.061,3.028Z",
    transform: "translate(-275.981 -285.916)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_303",
    "data-name": "Trazado 303",
    d: "M405.175,460a3.979,3.979,0,0,0,0,7.958h79.577a3.979,3.979,0,1,0,0-7.958Z",
    transform: "translate(-301.193 -295.03)",
    fill: "#58b957"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_304",
    "data-name": "Trazado 304",
    d: "M405.175,491a3.979,3.979,0,0,0,0,7.958h79.577a3.979,3.979,0,1,0,0-7.958Z",
    transform: "translate(-301.193 -307.054)",
    fill: "#58b957"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_305",
    "data-name": "Trazado 305",
    d: "M405.175,522a3.979,3.979,0,0,0,0,7.958h79.577a3.979,3.979,0,1,0,0-7.958Z",
    transform: "translate(-301.193 -319.078)",
    fill: "#58b957"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_306",
    "data-name": "Trazado 306",
    d: "M357.176,301a3.979,3.979,0,1,0,0,7.958h79.577a3.979,3.979,0,1,0,0-7.958Z",
    transform: "translate(-282.575 -233.359)",
    fill: "#58b957"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_307",
    "data-name": "Trazado 307",
    d: "M357.176,332a3.979,3.979,0,1,0,0,7.958h79.577a3.979,3.979,0,0,0,0-7.958Z",
    transform: "translate(-282.575 -245.383)",
    fill: "#58b957"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_308",
    "data-name": "Trazado 308",
    d: "M357.176,363a3.979,3.979,0,1,0,0,7.958h79.577a3.979,3.979,0,0,0,0-7.958Z",
    transform: "translate(-282.575 -257.407)",
    fill: "#58b957"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_204",
    "data-name": "Elipse 204",
    cx: 6.121,
    cy: 6.121,
    r: 6.121,
    transform: "translate(79.803 6.121)",
    fill: "#e6e6e6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawSurvey05S5);
export default __webpack_public_path__ + "static/media/undraw_survey_05s5.a1870717a321360ea025d689fa587cdf.svg";
export { ForwardRef as ReactComponent };